import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getDistrict = async () => {
  const { data } = await axios.get(`${api_base_url}/District/District`);
  return data;
};

//Get REgion By Area
export const getDistrictByRegionId = async (regionId) => {
  const { data } = await axios.get(
    `${api_base_url}/District/GetDistrictByRegionId/${regionId}`
  );
  return data;
};
// Insert New District
export const addDistrict = async (newDistrict) => {
  const { data } = await axios.post(`${api_base_url}/District/District`, {
    ...newDistrict[0],
  });
  return data;
};

// Update District
export const updateDistrict = async (updatedDistrict) => {
  const { data } = await axios.put(
    `${api_base_url}/District/District${updatedDistrict[0].districtId}`,
    updatedDistrict[0]
  );
  return data;
};
// Deactivate District
export const deleteDistrict = async (ids) => {
  await axios.delete(`${api_base_url}/District/District`, {
    data: ids,
  });
};
